export async function PracaComposicao(token: string | null) { 
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + `api/pracacomposicao`,
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }
    const response = await axios.request(options);
    return response;
}
